import treehats from '../../assets/img/treehats.gif'
import MultiHover from '../../components/MultiHover'

export default function SlideThree() {
  return (
    <div className='slide slide-three'>
      <div className='container clearfix'>
        <div id='' className='content grid-12'>
          <h1>
            Bio <MultiHover inputString={ '/////////////' } />
          </h1>

          <h2 className='bio'>
            Heralding from the Dallas, Texas that spaghetti westerns are made of, Melting Season is a
            multi-layered head-trip. A drummer from a young age and a practically-everything-else-ist from only slightly
            after that, Bruce Blay first came to prominence with the band Sleep Whale. His contributions on guitar, bass,
            violin, percussion and field recordings gave their music a sound that was described as a beautiful, somber
            patchwork and compared to The Books and Stars Of The Lid. Working on his own for the first time and expanding
            his arsenal to include kalimba, harp, noise makers, and most importantly saturated multi-tracked vocals,
            Melting Season was born. The layered approach to building sounds is borne of a diverse resume of experiences.
            Whether gaining his philosophy degree, cliff-jumping, wandering around Europe, recording bird sounds in Chile,
            or finding inspiration in weeping philosophers, comic books, and cats, this mad scientist of sound and emotion
            is an exploding musical alloy.
          </h2>

          <span className='selfie'>
            <img 
              src={ treehats }
              alt='treehats' />
          </span>

          <h2>
            <a className='brb' href='http://www.coolbrb.com'>
              BRB
            </a>
          </h2>
        </div>
      </div>
    </div>
  )
}

